// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .cs-grid {
  display: flex;
  flex-wrap: wrap;
  margin-right: 0;
  margin-left: 0;
  margin-top: 0;
}

::ng-deep .cs-card:last-child {
  margin-bottom: 0;
}
::ng-deep .cs-card {
  background-color: var(--surface-card);
  padding: 1rem;
  margin-bottom: 2rem;
  border: 1px solid var(--surface-border);
  border-radius: 10px; /*var(--border-radius);*/
}
::ng-deep .cs-align-items-center {
  align-items: center !important;
}
::ng-deep .cs-justify-content-between {
  justify-content: space-between !important;
}
::ng-deep .cs-flex {
  display: flex !important;
}
::ng-deep .cs-text-3xl {
  font-size: 1.75rem !important;
}
::ng-deep .cs-font-bold {
  font-weight: 700 !important;
}
::ng-deep .cs-text-color {
  color: var(--text-color) !important;
}
::ng-deep .cs-mb-0 {
  margin-bottom: 0rem !important;
}
::ng-deep .cs-mt-2 {
  margin-top: 0.5rem !important;
}
::ng-deep .cs-text-2xl {
  font-size: 1.5rem !important;
}
::ng-deep .cs-text-color-secondary {
  color: var(--text-color-secondary) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/secure/dashboard/content/dashboard-content.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;AACJ;;AAGI;EACI,gBAAA;AAAR;AAGI;EACI,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,uCAAA;EACA,mBAAA,EAAA,wBAAA;AADR;AAII;EACI,8BAAA;AAFR;AAKI;EACI,yCAAA;AAHR;AAMI;EACI,wBAAA;AAJR;AAOI;EACI,6BAAA;AALR;AAQI;EACI,2BAAA;AANR;AASI;EACI,mCAAA;AAPR;AAUI;EACI,8BAAA;AARR;AAWI;EACI,6BAAA;AATR;AAYI;EACI,4BAAA;AAVR;AAaI;EACI,6CAAA;AAXR","sourcesContent":["::ng-deep .cs-grid {\n    display: flex;\n    flex-wrap: wrap;\n    margin-right: 0;\n    margin-left: 0;\n    margin-top: 0;\n}\n\n::ng-deep {\n    .cs-card:last-child {\n        margin-bottom: 0;\n    }\n\n    .cs-card {\n        background-color: var(--surface-card);\n        padding: 1rem;\n        margin-bottom: 2rem;\n        border: 1px solid var(--surface-border);\n        border-radius: 10px; /*var(--border-radius);*/\n    }\n\n    .cs-align-items-center {\n        align-items: center !important;\n    }\n\n    .cs-justify-content-between {\n        justify-content: space-between !important;\n    }\n\n    .cs-flex {\n        display: flex !important;\n    }\n\n    .cs-text-3xl {\n        font-size: 1.75rem !important;\n    }\n\n    .cs-font-bold {\n        font-weight: 700 !important;\n    }\n\n    .cs-text-color {\n        color: var(--text-color) !important;\n    }\n\n    .cs-mb-0 {\n        margin-bottom: 0rem !important;\n    }\n\n    .cs-mt-2 {\n        margin-top: 0.5rem !important;\n    }\n\n    .cs-text-2xl {\n        font-size: 1.5rem !important;\n    }\n\n    .cs-text-color-secondary {\n        color: var(--text-color-secondary) !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
